import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 16, onChange, className = "" }) => {
  const interactive = typeof onChange === "function";
  const Item = interactive ? "button" : "span";
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Item
          key={i}
          {...(interactive
            ? { type: "button", "data-testid": `star-${i}`, onClick: () => onChange(i),
                className: "cursor-pointer transition-transform hover:scale-110 bg-transparent border-0 p-0" }
            : { className: "inline-flex" })}
        >
          <Star
            style={{ width: size, height: size }}
            className={i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "fill-transparent text-slate-300 dark:text-slate-600"}
          />
        </Item>
      ))}
    </div>
  );
};
